import {LoginCallback} from '@okta/okta-react';
import {Suspense, lazy} from 'react';
import {Navigate} from 'react-router-dom';
import {LoginPage, NotFoundPage, PrimaryPage, SecurePage} from '@/pages';
import {ROUTES} from '@/routes/constants';
import {Spinner} from '@/ui-kit';

const RostersModule = lazy(() => import('@/modules/rosters'));
const AuthorizationsModule = lazy(() => import('@/modules/authorizations'));
const EncountersModule = lazy(() => import('@/modules/encounters'));
const PayerConfigModule = lazy(() => import('@/modules/payer-config'));
const FaxesModule = lazy(() => import('@/modules/faxes'));

export const routes = [
  {
    element: <SecurePage />,
    children: [
      {
        element: <PrimaryPage />,
        children: [
          {
            path: ROUTES.BASE,
            element: <Navigate to={ROUTES.AUTHORIZATIONS} />,
          },
          {
            path: `${ROUTES.ROSTERS}/*`,
            element: (
              <Suspense fallback={<Spinner block={true} />}>
                <RostersModule />
              </Suspense>
            ),
          },
          {
            path: `${ROUTES.AUTHORIZATIONS}/*`,
            element: (
              <Suspense fallback={<Spinner block={true} />}>
                <AuthorizationsModule />
              </Suspense>
            ),
          },
          {
            path: `${ROUTES.ENCOUNTERS}/*`,
            element: (
              <Suspense fallback={<Spinner block={true} />}>
                <EncountersModule />
              </Suspense>
            ),
          },
          {
            path: `${ROUTES.PAYER_CONFIG}/*`,
            element: (
              <Suspense fallback={<Spinner block={true} />}>
                <PayerConfigModule />
              </Suspense>
            ),
          },
          {
            path: `${ROUTES.FAXES}/*`,
            element: (
              <Suspense fallback={<Spinner block={true} />}>
                <FaxesModule />
              </Suspense>
            ),
          },
        ],
      },
    ],
  },
  {
    path: ROUTES.LOGIN_CALLBACK,
    exact: true,
    element: <LoginCallback loadingElement={<Spinner overlay={true} />} />,
  },
  {
    path: ROUTES.LOGIN,
    element: <LoginPage />,
  },
  {
    path: ROUTES.NOT_FOUND,
    element: <NotFoundPage />,
  },
  {
    path: '*',
    element: <Navigate to={ROUTES.NOT_FOUND} />,
  },
];
